import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=f8c1cb94&scoped=true"
import script from "./AddNewDeposit.vue?vue&type=script&lang=ts"
export * from "./AddNewDeposit.vue?vue&type=script&lang=ts"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=f8c1cb94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c1cb94",
  null
  
)

export default component.exports